$(function(){
	setupBreadcrumb(['Variants', 'Gene Variants Overview'])

	// Public
	wireGeneNav({
		select: '#geneNavigator',
		button: '#exploreBtn',
		alert:  '#alertPlaceholder',
		buildUrl: gene => `/genes/variants/${gene}/`
	});

	// Curated (Manually) — no click handler needed; links are direct per tab

	// Mined (AI)
	wireGeneNav({
		select: '#geneNavigatorMined',
		button: '#exploreBtnMined',
		alert:  '#alertPlaceholderMined',
		buildUrl: gene => `/genes/variants/${gene}_ai`
	});

	// NEW: Protein Visualization
	wireGeneNav({
		select: '#geneNavigatorProtein',
		button: '#exploreBtnProtein',
		alert:  '#alertPlaceholderProtein',
		buildUrl: gene => `/genes/variants/${gene}_protein`
	});

	// Ensure selectpicker renders correctly when switching tabs
	$('a[data-toggle="tab"]').on('shown.bs.tab', function () {
		$('.selectpicker').selectpicker('refresh');
	});

	// Top links smooth-scroll
	scrollToElement('#literature-curated-top', '#top-header');
	scrollToElement('#literature-mined-top',   '#top-header');
	scrollToElement('#public-databases-top',   '#top-header');
	// NEW: proteins tab top link
	scrollToElement('#proteins-top',           '#top-header');

	// Activate tab from ?tab=public|curated|mined|proteins or #public/#curated/#mined/#proteins
	const params = new URLSearchParams(window.location.search);
	const qp = (params.get('tab') || '').toLowerCase();
	const hash = (window.location.hash || '').replace('#', '').toLowerCase();

	const allowed = ['public','curated','mined','proteins'];
	const target = allowed.includes(qp) ? qp
		: allowed.includes(hash) ? hash
		: null;

	if (target === 'public')   $('#public-tab').tab('show');
	if (target === 'curated')  $('#curated-tab').tab('show');
	if (target === 'mined')    $('#mined-tab').tab('show');
	if (target === 'proteins') $('#proteins-tab').tab('show');

	// Keep URL hash in sync when user changes tabs
	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		const id = $(e.target).attr('id'); // public-tab / curated-tab / mined-tab / proteins-tab
		if (id === 'public-tab')   history.replaceState(null, '', '#public');
		if (id === 'curated-tab')  history.replaceState(null, '', '#curated');
		if (id === 'mined-tab')    history.replaceState(null, '', '#mined');
		if (id === 'proteins-tab') history.replaceState(null, '', '#proteins');
	});
});

function wireGeneNav(cfg){
	const $select = $(cfg.select);
	const $btn    = $(cfg.button);
	const $alert  = $(cfg.alert);

	$btn.on('click', function(e){
		e.preventDefault();
		const gene = ($select.val() || '').trim();
		if (gene){
			window.location.href = cfg.buildUrl(gene);
		} else {
			renderWarn($alert, 'Please make a gene selection first.');
		}
	});
}

function renderWarn($container, msg){
	$container.html(
		'<div class="alert alert-warning alert-dismissible fade show" role="alert">'
		+ msg +
		'<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
		+ '<span aria-hidden="true">&times;</span>'
		+ '</button>'
		+ '</div>'
	);
}

function scrollToElement(sourceId, targetId) {
	$(sourceId).click(() => {
		$.scrollTo($(targetId), 500, { offset : -180 });
	});
}
